import { useEffect, useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
import { Box, Stack } from "@mui/material";
import ByzNurseSaveButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseSaveButton";
import ByzNurseDeleteButton from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNurseDeleteButton";
import ByzNursePrintButton2 from "src/components/core-components/mui/buttons/ByzNurseButton/ByzNursePrintButton2";
import ByzMuiSnackBar from "src/components/core-components/mui/ByzMuiSnackBar";
import { useTranslate } from "src/locales";
import ByzMuiAddButton from "src/components/core-components/mui/buttons/ByzMuiAddButton";

//MUZUN;445882;17022025
function NorthomtonScore() {

    const [alertOpen, setAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");
    const [alertSeverity, setAlertSeverity] = useState<"error" | "success">(
        "success"
    );

    const showAlert = (message: string, severity: "error" | "success") => {
        setAlertMessage(message);
        setAlertSeverity(severity);
        setAlertOpen(true);
    };

    useEffect(() => {
        //medcardService.create('data1',5);
        //medcardService.delete('data2',5);
        //medcardService.save('data3',5);
    }, []);

    const handleSaveMedcard = async () => {
        try {
            //const response = medcardService.save('data',5);
            const response = 'Medcard Kaydedildi';
            console.log("Save API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard kaydedilirken hata oluştu!", "error");
        }
    };

    const handleDeleteMedcard = async () => {
        try {
            //const response = medcardService.delete('data',5);
            const response = 'Medcard Silindi';
            console.log("Delete API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard silinirken hata oluştu!", "error");
        }
    };

    const handleAddMedcard = async () => {
        try {
            const response = "Medcard Eklendi";
            console.log("Delete API cevabı:", response);
            showAlert(response, "success");
        } catch (error) {
            console.error("Hata:", error);
            showAlert("Medcard Eklenirken hata oluştu!", "error");
        }
    };

    const { t } = useTranslate();

    return (
        <>
            <Stack
                sx={{ padding: "5px", marginBottom: "20px" }}
                mt={5}
                direction="row"
                spacing={2}
            >
                <ByzNurseSaveButton onClick={handleSaveMedcard} />
                <ByzMuiAddButton onClick={handleAddMedcard} />
                <ByzNurseDeleteButton onClick={handleDeleteMedcard} />
                <ByzNursePrintButton2 />
            </Stack>

            <Box sx={{ padding: '20px', width: '100%' }}>
                <Grid container spacing={2}>
                    <Grid md={11} xs={12} container direction={'column'} spacing={3}>
                        <Grid md={6} xs={6} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0' }}>
                            <ByzMuiTypography isTitle>
                                {t("northomton-score.title")}
                            </ByzMuiTypography>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px', display: 'flex' }}>
                                <ByzMuiTypography>
                                    {t("datetime")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiDateTimePicker sx={{ width: '100%', maxWidth: '300px' }} />
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'}>
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <ByzMuiTypography>
                                    {t("createdby")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }} >
                                <ByzMuiTextField sx={{ width: '300px' }} color='info' disabled label={t("createdby")} variant="outlined" />
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'}>
                            <Grid md={6} xs={6} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0' }}>
                                <ByzMuiTypography>
                                    <br />
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }} >
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.gestational-week")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.gestational-week")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.weight")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.weight")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.postnatal-age")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.postnatal-age")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.skin-integrity")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.skin-integrity")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.temperature-regulation")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.temperature-regulation")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.mobility")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.mobility")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.nutritional-status-oral-intake")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.nutritional-status-oral-intake")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid container alignItems="center" justifyContent="space-between">
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0', paddingRight: '10px' }}>
                                <ByzMuiTypography>
                                    {t("northomton-score.level-of-care")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} sx={{ paddingTop: '0px' }}>
                                <ByzMuiSelect
                                    renderInput={(params) => <ByzMuiTextField {...params} label={t("northomton-score.level-of-care")} variant="outlined" />}
                                    options={[]}
                                    sx={{ width: '100%', maxWidth: '300px' }}
                                    color="info"
                                    label={t("select")}
                                    placeholder={t("select")}
                                />
                            </Grid>
                        </Grid>

                        <Grid md={6} xs={6} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0' }}>
                            <ByzMuiTypography isTitle sx={{ textAlign: 'left' }}>
                                {t("northomton-score.extra-points-for-present-parameters")}
                            </ByzMuiTypography>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row">
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.clamped-cord")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row">
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'left' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.presence-of-intravenous-cannula")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.presence-of-extravasation")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.edema")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.presence-of-arterial-catheter")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.central-venous-catheter")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.wound")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.umbilical-catheter")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.birth-trauma")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.peritoneal-dialysis-catheter")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.diaper-dermatitis")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.presence-of-drain")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} sx={{ paddingTop: '0px' }}>
                            <Grid md={3} xs={3} sx={{ borderRight: '1px solid black', borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.electrolyte-imbalance")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={3} xs={3} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <Stack direction="row" spacing={2}>
                                    <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center' }} fontWeight={500} fontSize={'14px'}>
                                        {t("northomton-score.phototherapy")}
                                    </ByzMuiTypography>
                                </Stack>
                            </Grid>
                            <Grid md={6} xs={6}>
                                <Stack direction="row" spacing={3} sx={{ width: '400px' }}>
                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>

                                    <Box
                                        sx={{
                                            width: '140px',
                                            height: '50px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-start',
                                            pl: '2px',
                                        }}
                                    >
                                        <ByzMuiCheckBox color="info" />
                                    </Box>
                                </Stack>
                            </Grid>
                        </Grid>

                        <Grid md={6} xs={6} sx={{ backgroundColor: 'rgb(231, 239, 252)', borderBottom: '1px solid #E0E0E0' }}>
                            <ByzMuiTypography isTitle sx={{ display: 'flex', textAlign: 'center' }}>
                                {t("other")}
                            </ByzMuiTypography>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'} >
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center'}} fontWeight={500} fontSize={'14px'}>
                                    {t("score")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} >
                                <ByzMuiTextField sx={{ width: '300px' }} color='info' disabled label={t("score")} variant="outlined" />
                            </Grid>
                        </Grid>

                        <Grid container alignItems={'center'} justifyContent={'space-between'}>
                            <Grid md={6} xs={6} sx={{ borderBottom: '1px solid #E0E0E0' }}>
                                <ByzMuiTypography sx={{ display: 'flex', textAlign: 'center'}} fontWeight={500} fontSize={'14px'}>
                                    {t("note")}
                                </ByzMuiTypography>
                            </Grid>
                            <Grid md={6} xs={6} >
                                <ByzMuiTextField sx={{ width: '300px' }} color='info' label={t("note")} variant="outlined" />
                            </Grid>
                        </Grid>
                        <ByzMuiSnackBar
                            open={alertOpen}
                            onClose={() => setAlertOpen(false)}
                            title={
                                alertSeverity === "success"
                                    ? t("operation-successful")
                                    : t("error")
                            }
                            message={alertMessage}
                            type={alertSeverity}
                        />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default NorthomtonScore;